import {useQuery} from "@tanstack/react-query";

import type {AmenityConfig} from "../lib/amenity-config";
import {getAccessLogService} from "../lib/registry";

export default function useAmenityAccessLog(
  config: AmenityConfig,
  id: number | null,
  {enabled = true}: {enabled?: boolean} = {},
) {
  const service = getAccessLogService(config);

  const {data, isSuccess, isPending, isError, error, ...query} = useQuery({
    queryKey: [config.accessLogPath, id],
    queryFn: () => service.getAccessLog(id!),
    enabled: enabled && id != null,
    retry: false,
    refetchInterval: false,
    staleTime: Infinity,
  });

  const accessLog = id != null && isSuccess && data != null ? data : null;

  return {
    accessLog,
    isSuccess,
    // Disabled query (create mode) stays "pending" in TanStack Query — don't block the form.
    isPending: id != null && isPending,
    isError,
    error,
    ...query,
  };
}
